import React, { useState } from 'react';
import cn from 'classnames';
import { SearcherDatepicker } from '@lt/components';

import SearchParamsLabel from '../SearchParamsLabel';
import SearchParamsControl from '../SearchParamsControl';

import {
  getDateName,
  formatServerDate,
  formatDateToDayShort,
} from '../../../../../../utils/dateUtils';

import styles from './searchParamsDates.module.css';

interface SearchParamsDatesProps {
  isMobile?: boolean;
  startDate?: string | null;
  endDate?: string | null;
  onChangeDate: (value: string) => void;
  isHotelOnly: boolean;
  isArchived: boolean;
}

const SearchParamsDates = ({
  isMobile = false,
  startDate,
  endDate,
  onChangeDate,
  isHotelOnly,
  isArchived,
}: SearchParamsDatesProps) => {
  const [date, setDate] = useState(startDate ? new Date(startDate) : null);

  if (!date || !endDate) return null;

  const handleChange = (val: Date) => {
    const serverDate = formatServerDate(val);
    onChangeDate(serverDate);
    setDate(val);
  };

  return (
    <div className={styles.container}>
      <div className={styles.dates}>
        <div className={styles.date}>
          <div className={cn(styles.text, { [styles.mobileText]: isMobile })}>
            {formatDateToDayShort(startDate)}
          </div>
          <span className={styles.week}>
            {isMobile ? getDateName(startDate, 'eee') : getDateName(startDate)}
          </span>
        </div>
        <span className={cn(styles.text, { [styles.mobileText]: isMobile })}>
          —
        </span>
        <div className={styles.date}>
          <div className={cn(styles.text, { [styles.mobileText]: isMobile })}>
            {formatDateToDayShort(endDate)}
          </div>
          <span className={styles.week}>
            {isMobile ? getDateName(endDate, 'eee') : getDateName(endDate)}
          </span>
        </div>
      </div>
      <div>
        {!isArchived && !isHotelOnly && (
          <SearcherDatepicker
            onChangeDate={handleChange}
            selectedDate={date}
            isMobile={isMobile}
            monthsShown={10}
            CustomControl={SearchParamsControl}
            CustomLabel={SearchParamsLabel}
          />
        )}
      </div>
    </div>
  );
};

export default SearchParamsDates;
